import { render, staticRenderFns } from "./users-role-history-data.vue?vue&type=template&id=0e277d45&scoped=true&"
import script from "./users-role-history-data.vue?vue&type=script&lang=js&"
export * from "./users-role-history-data.vue?vue&type=script&lang=js&"
import style0 from "./users-role-history-data.vue?vue&type=style&index=0&id=0e277d45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e277d45",
  null
  
)

component.options.__file = "users-role-history-data.vue"
export default component.exports